import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface VerticalStepItem {
  title: string;
  icon?: string;
}

export interface VerticalStepState {
  completed: boolean;
  hasError: boolean;
  active: boolean;
}

@Component({
  selector: 'app-vertical-stepper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vertical-stepper.component.html'
})
export class VerticalStepperComponent {
  steps          = input.required<VerticalStepItem[]>();
  activeIndex    = input.required<number>();
  maxVisitedStep = input.required<number>();
  stepStates     = input.required<VerticalStepState[]>();

  stepClick = output<number>();

  onStepClick(index: number): void {
    if (index <= this.maxVisitedStep()) {
      this.stepClick.emit(index);
    }
  }
}
